module.exports = __webpack_public_path__ + "static/media/preventivo_verde.7bdda344.svg";